import { render } from "./Planet.vue?vue&type=template&id=a3003f0c"
import script from "./Planet.vue?vue&type=script&lang=js"
export * from "./Planet.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__